var NebolitTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      "#0097A7",  /* dark  blue */
        primary2color:      "#00BCD4",  /* light blue */
        primary3color:      "#E0E0E0",  /* gray       */
        accent1color :      "#E73677",  /* pink       */
        accent2color :      "#D0FFCA",  /* green      */
        accent3color :      "#FF9797",  /* red        */
        textColor    :      "#212121",
        canvasColor  :      "#f3f3f3",
        alternateTextColor: "#00BCD4",  // Button background color.
    }
};

export default NebolitTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/NebolitTheme.js
 **/